export const PersonTypeEnum = {
    COLLABORATOR: 1,
    CUSTOMER: 2,
    SUPPLIER: 3,
    TEACHER: 4,
    LEADER: 5

}


// WEBPACK FOOTER //
// ./src/enums/PersonTypeEnum.js